import {
  LocationMutationRequest,
  LocationMutationResult,
} from '@qkindex/contracts';
import { httpsCallable } from 'firebase/functions';
import {
  CollectionAiPolicyDocument,
  CollectionAuthorityRequest,
  CollectionCapacityCapabilityRequest,
  CollectionCapacityCapabilityResult,
  CollectionBulkUpdateRequest,
  CollectionBulkUpdateResult,
  CollectionPermanentDeleteRequest,
  CollectionPermanentDeleteResult,
  ListCollectionPeopleRequest,
  ListCollectionPeopleResult,
  CreateCollectionInvitationRequest,
  ResendCollectionInvitationRequest,
  RevokeCollectionInvitationRequest,
  CollectionInvitationMutationResult,
  ExchangeCollectionInvitationRequest,
  ExchangeCollectionInvitationResult,
  AcceptCollectionInvitationRequest,
  AcceptCollectionInvitationResult,
  DeclineCollectionInvitationRequest,
  DeclineCollectionInvitationResult,
  ChangeCollectionMemberRoleRequest,
  RemoveCollectionMemberRequest,
  LeaveCollectionRequest,
  CollectionMembershipMutationResult,
  CreateCollectionRequest,
  CreateCollectionResult,
  StartCollectionTransferRequest,
  CollectionTransferActionRequest,
  GetCollectionTransferRequest,
  CollectionTransferResult,
  DeleteCollectionRequest,
  DeleteCollectionResult,
  UpdateCollectionRequest,
  UpdateCollectionResult,
  CollectionAiCapabilityRequest,
  CollectionAiCapabilityResult,
  UpdateCollectionAiPolicyRequest,
  UpdateCollectionAiPolicyResult,
  AiCreditHistoryRequest,
  CreditTransactionHistoryResult,
  AiCreditPurchaseHistoryResult,
  AiCreditUsageHistoryResult,
  AiCreditWalletSummaryResult,
  CreateAiCreditCheckoutRequest,
  CreateAiCreditCheckoutResult,
  BillingSummaryRequest,
  BillingSummaryResult,
  ResolvePersonalBillingAccountResult,
  ChangeUsernameRequest,
  ChangeUsernameResult,
  CheckUsernameAvailabilityRequest,
  CheckUsernameAvailabilityResult,
  ResolveCollectionUsernameRequest,
  ResolveCollectionUsernameResult,
} from '@qkindex/contracts';
import { functions } from '../firebase';

export const deleteMultipleItems = httpsCallable<
  CollectionPermanentDeleteRequest,
  CollectionPermanentDeleteResult
>(functions, 'deleteMultipleItems');
export const updateMultipleItems = httpsCallable<
  CollectionBulkUpdateRequest,
  CollectionBulkUpdateResult
>(functions, 'updateMultipleItems');
export const getCollectionAiCapability = httpsCallable<
  CollectionAiCapabilityRequest,
  CollectionAiCapabilityResult
>(functions, 'getCollectionAiCapability');
export const updateCollectionAiPolicy = httpsCallable<
  UpdateCollectionAiPolicyRequest,
  UpdateCollectionAiPolicyResult
>(functions, 'updateCollectionAiPolicy');
export const getAiCreditWalletSummary = httpsCallable<
  Record<string, never>,
  AiCreditWalletSummaryResult
>(functions, 'getAiCreditWalletSummary');
export const listAiCreditPurchases = httpsCallable<
  AiCreditHistoryRequest,
  AiCreditPurchaseHistoryResult
>(functions, 'listAiCreditPurchases');
export const listAiCreditUsage = httpsCallable<
  AiCreditHistoryRequest,
  AiCreditUsageHistoryResult
>(functions, 'listAiCreditUsage');
export const listCreditTransactions = httpsCallable<
  AiCreditHistoryRequest,
  CreditTransactionHistoryResult
>(functions, 'listCreditTransactions');
export const createAiCreditCheckout = httpsCallable<
  CreateAiCreditCheckoutRequest,
  CreateAiCreditCheckoutResult
>(functions, 'createAiCreditCheckout');
export const getBillingSummary = httpsCallable<
  BillingSummaryRequest,
  BillingSummaryResult
>(functions, 'getBillingSummary');
export const resolvePersonalBillingAccount = httpsCallable<
  Record<string, never>,
  ResolvePersonalBillingAccountResult
>(functions, 'resolvePersonalBillingAccount');
export const changeUsername = httpsCallable<
  ChangeUsernameRequest,
  ChangeUsernameResult
>(functions, 'changeUsername');
export const checkUsernameAvailability = httpsCallable<
  CheckUsernameAvailabilityRequest,
  CheckUsernameAvailabilityResult
>(functions, 'checkUsernameAvailability');
export const resolveCollectionUsername = httpsCallable<
  ResolveCollectionUsernameRequest,
  ResolveCollectionUsernameResult
>(functions, 'resolveCollectionUsername');
export const createCollection = httpsCallable<
  CreateCollectionRequest,
  CreateCollectionResult
>(functions, 'createCollection');
export const listCollectionPeople = httpsCallable<
  ListCollectionPeopleRequest,
  ListCollectionPeopleResult
>(functions, 'listCollectionPeople');
export const createCollectionInvitation = httpsCallable<
  CreateCollectionInvitationRequest,
  CollectionInvitationMutationResult
>(functions, 'createCollectionInvitation');
export const resendCollectionInvitation = httpsCallable<
  ResendCollectionInvitationRequest,
  CollectionInvitationMutationResult
>(functions, 'resendCollectionInvitation');
export const revokeCollectionInvitation = httpsCallable<
  RevokeCollectionInvitationRequest,
  CollectionInvitationMutationResult
>(functions, 'revokeCollectionInvitation');
export const exchangeCollectionInvitation = httpsCallable<
  ExchangeCollectionInvitationRequest,
  ExchangeCollectionInvitationResult
>(functions, 'exchangeCollectionInvitation');
export const acceptCollectionInvitation = httpsCallable<
  AcceptCollectionInvitationRequest,
  AcceptCollectionInvitationResult
>(functions, 'acceptCollectionInvitation');
export const declineCollectionInvitation = httpsCallable<
  DeclineCollectionInvitationRequest,
  DeclineCollectionInvitationResult
>(functions, 'declineCollectionInvitation');
export const changeCollectionMemberRole = httpsCallable<
  ChangeCollectionMemberRoleRequest,
  CollectionMembershipMutationResult
>(functions, 'changeCollectionMemberRole');
export const removeCollectionMember = httpsCallable<
  RemoveCollectionMemberRequest,
  CollectionMembershipMutationResult
>(functions, 'removeCollectionMember');
export const leaveCollection = httpsCallable<
  LeaveCollectionRequest,
  CollectionMembershipMutationResult
>(functions, 'leaveCollection');
export const getCollectionCapacityCapability = httpsCallable<
  CollectionCapacityCapabilityRequest,
  CollectionCapacityCapabilityResult
>(functions, 'getCollectionCapacityCapability');
export const startCollectionTransfer = httpsCallable<
  StartCollectionTransferRequest,
  CollectionTransferResult
>(functions, 'startCollectionTransfer');
export const getCollectionTransfer = httpsCallable<
  GetCollectionTransferRequest,
  CollectionTransferResult | null
>(functions, 'getCollectionTransfer');
export const acceptCollectionTransfer = httpsCallable<
  CollectionTransferActionRequest,
  CollectionTransferResult
>(functions, 'acceptCollectionTransfer');
export const cancelCollectionTransfer = httpsCallable<
  CollectionTransferActionRequest,
  CollectionTransferResult
>(functions, 'cancelCollectionTransfer');
export const expireCollectionTransfer = httpsCallable<
  CollectionTransferActionRequest,
  CollectionTransferResult
>(functions, 'expireCollectionTransfer');
export const getLocalInvitationDelivery = httpsCallable<
  { collectionId: string; invitationId: string },
  {
    collectionId: string;
    invitationId: string;
    normalizedEmail: string;
    rawToken: string;
  }
>(functions, 'getLocalInvitationDelivery');

export const getCollectionAiPolicy = httpsCallable<
  CollectionAuthorityRequest,
  CollectionAiPolicyDocument
>(functions, 'getCollectionAiPolicy');

export const updateCollection = httpsCallable<
  UpdateCollectionRequest,
  UpdateCollectionResult
>(functions, 'updateCollection');
export const deleteCollection = httpsCallable<
  DeleteCollectionRequest,
  DeleteCollectionResult
>(functions, 'deleteCollection');

export const mutateCollectionLocation = httpsCallable<
  LocationMutationRequest,
  LocationMutationResult
>(functions, 'mutateCollectionLocation');
